import { createContext, useContext } from 'react';
import type { useProgram } from './use-program';

export const ProgramContext = createContext<ReturnType<
  typeof useProgram
> | null>(null);

export function useProgramContext() {
  return useContext(ProgramContext);
}
